module.exports = __webpack_public_path__ + "static/assets/90e939d170002c61a50116ed55763b19.svg";